import React, { HTMLAttributes, PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';

import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import { Nullable } from '@/types/common';

interface Props extends HTMLAttributes<HTMLDivElement> {
  latitude: number;
  longitude: number;
}

const KakaoMap = ({ latitude, longitude, ...props }: PropsWithChildren<Props>) => {
  const [loaderElement, setLoaderElement] = useState<Nullable<HTMLDivElement>>();
  const entry = useIntersectionObserver({
    target: loaderElement,
  });

  useEffect(() => {
    if (!entry?.isIntersecting) return;

    const mapScript = document.createElement('script');

    mapScript.async = true;
    mapScript.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${
      process.env.NEXT_PUBLIC_KAKAO_JS_KEY ?? ''
    }&autoload=false`;

    document.head.appendChild(mapScript);

    const onLoadKakaoMap = () => {
      window.kakao.maps.load(() => {
        const container = document.getElementById('map');

        if (!container) return;

        const options = {
          center: new window.kakao.maps.LatLng(latitude, longitude),
          draggable: false,
        };
        const map = new window.kakao.maps.Map(container, options);
        const markerPosition = new window.kakao.maps.LatLng(latitude, longitude);
        const marker = new window.kakao.maps.Marker({
          position: markerPosition,
        });
        marker.setMap(map);
      });
    };
    mapScript.addEventListener('load', onLoadKakaoMap);

    return () => mapScript.removeEventListener('load', onLoadKakaoMap);
  }, [entry, latitude, longitude]);
  return (
    <MapWrapper ref={(ref) => setLoaderElement(ref)} {...props}>
      <Map id='map' onScroll={undefined} />
    </MapWrapper>
  );
};

export default KakaoMap;

const MapWrapper = styled.div``;

const Map = styled.div`
  width: 100%;
  height: 100%;
`;
